import { render, staticRenderFns } from "./TableNhapDienNuocNoiBo.vue?vue&type=template&id=de2043c2"
import script from "./TableNhapDienNuocNoiBo.vue?vue&type=script&lang=js"
export * from "./TableNhapDienNuocNoiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports